export { default } from './CollectionSection';
